export default {
//  getGameList (store, data) { // 进首页获得游戏数据存入sessionStorage
//  }
}



// WEBPACK FOOTER //
// ./src/store/actions/actions.js